import { Pipe, PipeTransform } from "@angular/core";
import { AppConsts } from "../AppConsts";

/**
 *  Case Separator Pipe
 * */
@Pipe({ name: "caseSeparator" })
export class CaseSeparatorPipe implements PipeTransform {

    /**
     * Takes a string: caseSeparatorPipe
     * And converts it to: Case Sepatator Pipe
     * @param value - string to transform
     */
    transform(value: string) {

        if (value === null || value === undefined || value.trim() === '')
            return value;

        const { regexDefinitions } = AppConsts;
        // adding space between strings
        const result = value
            // Adds spaces before uppercase 
            .replace(regexDefinitions.capitalLetters, ' $1')
            // Removes additional spaces if they exist
            .replace(regexDefinitions.multipleSpaceCharacters, " ");

        return `${result.charAt(0).toUpperCase()}${result.slice(1)}`.trim();
    }
}
